import { call, put, takeEvery } from 'redux-saga/effects';
import { setBeforeChart, setInitChart } from './actions';
import {
	FETCH_BEFORE_CHART,
	FETCH_INIT_CHART,
	FETCH_LOOKBACK_CHART,
} from './constants';

import { getChartData } from './api';

function* asyncFetchInitChart(param: any) {
	const { id, symbol, filter } = param.payload.param;
	const resolve = param.payload.param.resolve || (() => null);
	const reject = param.payload.param.reject || (() => null);
	const date = new Date();
	const limit = symbol.includes('5')
		? 370
		: symbol.includes('60')
			? 370
			: symbol.includes('1D')
				? 370
				: symbol.includes('1')
					? 370
					: 370;
	const response: object = yield call(getChartData, `charts?symbol=${symbol}&filter=${filter}&stopTime=${Math.floor(date.getTime() / 1000)}&limit=${limit}`);
	yield put(setInitChart(response, id, symbol));
	if (response) {
		resolve(response);
	} else {
		reject(response);
	}
}

function* asyncFetchBeforeChart(param: any) {
	const { date, id, limit, symbol, filter } = param.payload.param;
	const response: object = yield call(getChartData, `charts?symbol=${symbol}&stopTime=${date}&limit=${limit}&filter=${filter}`);
	yield put(setBeforeChart(response, id, symbol));
}

function* asyncFetchLookbackChart(param: any) {
	const { id, stopTime, symbol, filter } = param.payload.param;
	const response: object = yield call(getChartData, `charts?symbol=${symbol}&stopTime=${stopTime}&filter=${filter}`);
	yield put(setInitChart(response, id, symbol));
}

export function* sagaWatcher() {
	yield takeEvery(FETCH_INIT_CHART, asyncFetchInitChart);
	yield takeEvery(FETCH_BEFORE_CHART, asyncFetchBeforeChart);
	yield takeEvery(FETCH_LOOKBACK_CHART, asyncFetchLookbackChart);
}

const gens = [sagaWatcher()];
export default gens;
